<section class="login_grid">
<div class="login_logo">
  <img class="logo" src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Header/logo.png" alt="Miles Education">
</div>
<div class="lms_login">
  <div class="login_sec">
    <div class="container-fluid">
      <div class="row login_form">
          <div class="col-sm-6">
          <div class="login_form_lft">
              <div class="login_left">
                  <img class="login_left_img" src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/all-images/statue_of_liberty_new.png" alt="Miles Education">
              </div>
          </div>
          </div>
          <div class="col-sm-6">
          <div class="login_form_rgt">
            <div class="w-3/4 my-auto">
       
              <div class=" rounded p-6 text-center text-lg">
                <div class="flex justify-center my-2">
                <img style="width: 35%; text-align: center;" src ="../../../assets/svg/snapRedirectLms.svg"></div>
                <span class="font-bold mr-1 customBold text-danger" style="font-size: 1.3rem;">Snap!</span>
                Something went wrong. Head over to <span class="text-black font-bold">Modules/Assignment</span> in the left-hand menu and choose your section to get back on track.
              </div>
          </div>
              <!-- <div class="brand_img">
                  <img class="login_left_img" src="../assets/brands.png" alt="Miles Education">
              </div> -->
              <!-- <div class="form_login"> -->
                  <!-- <h4>Login To Miles CPA LMS</h4> -->
                  <!-- <p>Discover the Pinnacle of CPA Exam Preparation</p> -->
                  <!-- <span class="text-center" style="color: red;" *ngIf="errorMessage"><br>{{errorMessage}}</span> -->
                  <!-- <form [formGroup]="loginForm">
                      <div style="position: relative;">
                        <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Login/mailIcon.svg"
                          class="left_icon">
                        <input type="text" class="form_control" placeholder="Username" formControlName="registration_id">
                      </div>
                      <div style="position: relative; margin-bottom: 25px;">
                        <img src="https://storage.googleapis.com/miles-next_website-lms-gptool/LMS-2024/Login/passwordIcon.svg"
                          class="left_icon">
                        <input type="{{showHidePass === 'fa-eye-slash'?'password':'text'}}" class="form_control"
                          placeholder="Password" formControlName="password">
                        <span class="toggle_icon">
                          <i class=" fas {{showHidePass}} active" style="font-size: 1rem; color: rgb(156 163 175);"
                            (click)="showHidePassword()"></i>
                        </span>
                      </div>

                      <button *ngIf="is_clicked==false" [disabled]="!loginForm.valid" mdbWavesEffect (click)="onSubmit()"
                        class="blue_btn">Continue </button>
                      <button *ngIf="is_clicked==true" [disabled] class="blue_btn">Continue <i class="fa fa-spinner fa-spin"></i>
                      </button>
                    </form> -->
                    <!-- <a routerLink="/unable-to-login" class="forgot_pwd" style="color:  #06345B">Forgot Password? </a> -->
              <!-- </div> -->
          </div>
          </div>

      </div>
    </div>
  </div>
</div>
</section>
